module.exports = __webpack_public_path__ + "img/andy_pasos1.4296034e.svg";